module.exports = __webpack_public_path__ + "img/interview-640_white.eb9d2669.png";